export default __webpack_public_path__ + "static/media/purchase_success_icon.fa0b3987.svg";